package io.zsoft.models

import io.zsoft.util.Constants.SHORT_TEXT

enum class Experience(
    val number: String,
    val jobPosition: String,
    val description: String,
    val company: String,
    val from: String,
    val to: String
) {
    First(
        number = "01",
        jobPosition = "Kotlin Multi-Platform Developer",
        description = SHORT_TEXT,
        company = "Google",
        from = "February 2022",
        to = "NOW",
    ),
    Second(
        number = "02",
        jobPosition = "Mobile Developer",
        description = SHORT_TEXT,
        company = "Facebook",
        from = "January 2021",
        to = "October 2021",
    ),
    Third(
        number = "03",
        jobPosition = "Freelancer",
        description = SHORT_TEXT,
        company = "Netflix",
        from = "March 2020",
        to = "August 2020",
    )
}